// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-cards[data-v-c3472b80]{grid-gap:20px;display:grid;grid-template-columns:repeat(3,1fr);list-style:none;margin-top:2em;padding-left:0}.icon-cards li[data-v-c3472b80]{display:flex;flex-direction:column;margin:1em 0;text-align:center}.icon-cards li svg[data-v-c3472b80]{font-size:3em;margin:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
